import ApiService from "@/services";
import { handleApiError } from "../helpers";
import { defaultListId } from "../shared";

const state = {
  currentConfig: null,
  currentListId: null,
  defaultConfig: null,
};

const getters = {
  bookingEngineId: (state) => state.currentListId || defaultListId,
};

const mutations = {
  setConfigState(state, { current, main, listId }) {
    state.defaultConfig = main;
    state.currentListId = current?.id || listId;
    state.currentConfig = current;
  },
};

const actions = {
  async getConfigData({ commit }, { listId, domain = null }) {
    try {
      const params = {};
      if (domain) {
        params.domain = domain;
      }
      const {
        data: { current, main },
      } = await ApiService.get(`config/${listId}`, { params });
      commit("setConfigState", { current, main, listId });
      return current;
    } catch (error) {
      throw handleApiError(error);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
